import { apiWrapper } from "@/services/api";

// BFFから`POST /dbs/login`でx-bks-sessionidを取得する処理
export const getDbsSessionId = async () => {
  try {
    const params = { ent_id: "EMT" };
    const resp = await apiWrapper(
      "POST",
      `dbs/login`,
      params,
      false,
      null,
      "Migrated"
    );
    const dbsSessionId = resp.data["x-bks-sessionid"];
    return dbsSessionId;
  } catch (err) {
    console.log('ERROR"" getDbsSessionId()', err);
  }
};
